module.exports = __webpack_public_path__ + "static/media/pg24.31ef10a9.jpg";